import Modal from '@acorn-portal/shared/src/components-v2/modal';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { Button, DialogTitle, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import ModalContentWrapper from '../modal-content-wrapper';

interface IQuoteExpiredModal {
	open: boolean;
}

const QuoteExpiredModal = ({ open }: IQuoteExpiredModal) => {
	const navigate = useNavigate();
	return (
		<Modal open={open}>
			<ModalContentWrapper>
				<DialogTitle component='h2' variant='h5' sx={{ fontWeight: 700, textAlign: 'center', pt: 0 }}>
					Your session has expired
				</DialogTitle>
				<Typography sx={{ textAlign: 'center', mb: 2 }}>
					Your cancellation request has expired. Return to your policy and try again.
				</Typography>

				<Button
					variant='contained'
					color='primary'
					onClick={() => navigate(ROUTE_PATHS.policyDetails)}
					sx={{ mt: '8px', fontSize: '18px', width: '100%', textTransform: 'none' }}
				>
					Return to policy details
				</Button>
			</ModalContentWrapper>
		</Modal>
	);
};

export default QuoteExpiredModal;
